<div [ngClass]="{
    'hidden': router.url.includes('/iniciar-sesion') ||
            router.url.includes('/registrarse') ||
            router.url.includes('/restablecer-contrasena') ||
            router.url.includes('/terms-conditions')
    }">
    <app-navbar [logoGov]="logoGov"></app-navbar>
</div>


<router-outlet></router-outlet>

<app-alerts></app-alerts>

<div [ngClass]="{
    'hidden': router.url.includes('/iniciar-sesion') ||
            router.url.includes('/registrarse') ||
            router.url.includes('/restablecer-contrasena') ||
            router.url.includes('/terms-conditions')
    }">
    <app-footer [footerImgs]="footerImgs"></app-footer>
    <ngx-scrolltop></ngx-scrolltop>
</div>
